import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DialogModule } from "@bfx/primeng/dialog";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";
import { TabViewModule } from "@bfx/primeng/tabview";

import { BfxBlotterOpsIntComponent } from "./bfx-blotter-ops-int.component";
import { BfxBlotterOpsIntContextMenuComponent } from "./bfx-blotter-ops-int-contextmenu.component";

import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterOpsIntActionsService } from "./services/bfx-blotter-ops-int-actions.service";
import { BfxBlotterOpsIntContextMenuService } from "./services/bfx-blotter-ops-int-contextmenu.service";
import { BfxBlotterOpsIntService } from "./services/bfx-blotter-ops-int.service";

import { BfxBlotterFilterModule } from "../bfx-blotter-filter/bfx-blotter-filter.module";
import { BfxBlotterOpsIntFilterService } from "./services/bfx-blotter-ops-int-filter.service";
import { BfxBlotterOpsIntTopMenuComponent } from "./bfx-blotter-ops-int-top-menu.component";
import { BfxBlotterOpsInBlotterFilterBarComponent } from "./bfx-blotter-ops-int-blotter-filter-bar.component";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxMenusModule } from "../bfx-menus/bfx-menus.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { OpsIntTooltip } from "./renderers/OpsIntTooltip";
import { TieredMenuModule } from "@bfx/primeng/tieredmenu";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
// import { BfxCommsOpsIntService } from "./services/bfx-comms-ops-int.service";

@NgModule({
  declarations: [
    BfxBlotterOpsIntComponent,
    BfxBlotterOpsIntContextMenuComponent,
    BfxBlotterOpsIntTopMenuComponent,
    BfxBlotterOpsInBlotterFilterBarComponent,
    OpsIntTooltip,
  ],
  imports: [
    AgGridModule.withComponents([]),
    AutoCompleteModule,
    BaseComponentsModule,
    BfxBlotterFilterModule,
    BfxElementsLibraryModule,
    BfxMenusModule,
    BfxSharedModule,
    ButtonModule,
    CheckboxModule,
    CommonModule,
    DialogModule,
    FormsModule,
    OverlayPanelModule,
    TabViewModule,
    TieredMenuModule,
    TranslateModule,
  ],
  providers: [
    BfxBaseBlotterColumnSelectorService,
    BfxBlotterOpsIntActionsService,
    BfxBlotterOpsIntContextMenuService,
    BfxBlotterOpsIntFilterService,
    BfxBlotterOpsIntService,
    //  BfxCommsOpsIntService,
  ],
  exports: [BfxBlotterOpsIntComponent],
  bootstrap: [BfxBlotterOpsIntComponent],
})
export class BfxBlotterOpsIntModule {}
